
export const progress = {

    methods: {
        progressColor(percent) {
            if (percent < 20) return 'green darken-4';
            if (percent < 40) return 'green darken-3';
            if (percent < 60) return 'green darken-2';
            if (percent < 80) return 'green darken-1';
            return 'green';
        },
    },
};

